import { render } from "./ShoppingCart.vue?vue&type=template&id=4f220e48"
import script from "./ShoppingCart.vue?vue&type=script&lang=js"
export * from "./ShoppingCart.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__